import { getTCGPlayerProductId } from "@/lib/tcgplayer/getCardPrice";
import { SupportedGames } from "@/types/game";
import { getTcgplayerConfig } from "@/games";
const IMPACT_AFFILIATE_URL =
  "https://partner.tcgplayer.com/c/5267069/1830156/21018";

export function getTCGPlayerUrl(id: number, medium: string) {
  const tcgplayerUrl = `https://www.tcgplayer.com/product/${id}`;
  return `${IMPACT_AFFILIATE_URL}?u=${tcgplayerUrl}&subId1=${medium}`;
}

export function getTCGPlayerMassEntryURL(
  game: SupportedGames,
  decklist: string,
  medium: string,
) {
  // todo, join these cards correctly
  let tcgPlayerCards: string[] = [];
  let cards = decklist.split(";");
  for (const card of cards) {
    const [count, id] = card.split("x");
    if (id) {
      const tcgplayerProductId = getTCGPlayerProductId(game, id);
      if (tcgplayerProductId !== undefined) {
        tcgPlayerCards.push(`${count}-${tcgplayerProductId}`);
      }
    }
  }
  let massEntry = tcgPlayerCards.join("||");

  const productLine = getTcgplayerConfig(game)?.productLine;

  const tcgplayerUrl = encodeURIComponent(
    `https://www.tcgplayer.com/massentry?c=${massEntry}&productline=${productLine}`,
  );

  return `${IMPACT_AFFILIATE_URL}?&subId1=${medium}&u=${tcgplayerUrl}`;
}
